// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_l0-0";